module.exports = __webpack_public_path__ + "static/img/research.2889a5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/research.jpg
// module id = t6BO
// module chunks = 3